import type {ChartSeries} from "~/components/analyticsWidgets/redBoxes/types";

type NormalisedYAxisLabels = {
    left: Array<string> | null;
    right: Array<string> | null;
};

type AreaGradientProps = {
    color: string;
    id: string;
    withGradient: boolean | undefined;
    fillOpacity: number | undefined;
};

export function AreaGradient({color, id, withGradient, fillOpacity}: AreaGradientProps) {
    return (
        <>
            {withGradient === true ? (
                <linearGradient
                    id={id}
                    x1="0"
                    y1="0"
                    x2="0"
                    y2="1"
                >
                    <stop
                        offset="0%"
                        stopColor={color}
                        stopOpacity={fillOpacity}
                    />
                    <stop
                        offset="100%"
                        stopColor="#000000"
                        stopOpacity={fillOpacity}
                    />
                </linearGradient>
            ) : (
                <linearGradient
                    id={id}
                    x1="0"
                    y1="0"
                    x2="0"
                    y2="1"
                >
                    <stop
                        stopColor={color}
                        stopOpacity={fillOpacity ?? 0.2}
                    />
                </linearGradient>
            )}
        </>
    );
}

export function getNormalisedYAxisLabelsFromChartSeries(chartSeries: Array<ChartSeries>): NormalisedYAxisLabels {
    const yAxes: NormalisedYAxisLabels = {left: null, right: null};

    for (const series of chartSeries) {
        if (yAxes.left === null && series.yAxisId === "left") {
            yAxes.left = [series.label];
        } else if (series.yAxisId === "left" && yAxes.left !== null) {
            yAxes.left.push(series.label);
        }

        if (yAxes.right === null && series.yAxisId === "right") {
            yAxes.right = [series.label];
        } else if (series.yAxisId === "right" && yAxes.right !== null) {
            yAxes.right.push(series.label);
        }
    }

    return yAxes;
}
